'use strict';

var $ = require('jquery');
var basePage = require('../pages/base-page.js');

var td 	= require('throttle-debounce');
var layout = require('../ui/layout.js');
var tables = require('../ui/tables.js');

var classNames = {
    tablesaw: 'tablesaw',
    trimDerivativeList: 'trim-derivative-list',
    trimDerivativeListTable: 'trim-derivative-list__table'
};

var tablesInitialised;

function initTables() {
    tables.init();
    tablesInitialised = true;
}

function destroyTables() {
    tables.destroy();
    tablesInitialised = false;
}

function registerResizeEvent() {
    $(window).on('resize.modelTax', td.debounce(50, function () {
        if (layout.isMobile() && !tablesInitialised) {
            initTables();
        }

        if (!layout.isMobile() && tablesInitialised) {
            destroyTables();
        }
    }));
}

function loadTaxTables($page) {
    var $taxTable = $page.findByBem(classNames.trimDerivativeListTable);

    if ($taxTable.length > 0) {
        if (layout.isMobile()) {
            initTables();
        }

        registerResizeEvent();
    }
}


basePage.init = function() {
	basePage.initBasePage();

	var $context = $('#modelTaxPage');
	loadTaxTables($context);
    
};

module.exports = basePage;